import { useEffect } from "react";

export const useScrollTop = () => {
  useEffect(() => {
    const root = document.getElementById("root");
    if (root) {
      root.scrollTo(0, 0);
    }
  }, []);
};
